<!--
import { log } from 'util';
 * @Author: your name
 * @Date: 2020-10-21 11:37:00
 * @LastEditTime: 2021-03-22 11:11:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\views\Home\AdminMember\AdminGraph.vue
-->
<template>
  <div class="graph">
    <el-row class="graphHeader" v-if="$route.name=='exportAdminGraph'">
      <span class="headerLeft">上海信用服务行业综合智慧数据库管理平台</span>
      <span class="headerMiddle">信用协会统计报表</span>
      <img class="headerImg" src="@/assets/img/headerHtml.png" alt="">
    </el-row>
    <div id="adminGraph" ref="adminGraph" :class="{graphBody:$route.name=='exportAdminGraph'?true:false}">
      <!-- 导出html -->
      <div ref="export" class="exportHtml " @dblclick="exportHtml" v-if="$route.name=='AdminGraph'" @mousedown="mousedown" @mousemove="mousemove" @mouseup="mouseup">
        <img src="@/assets/img/exporthtml.png" alt=""> 导出html
      </div>
      <p style="color:#909399;line-height:40px;">上次生成统计时间：2020-02-02</p>
      <el-row class="rowOne">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
          <div @click="toAdminManage(0)" :style="$route.name=='exportAdminGraph'?'':'cursor:pointer;'">
            <img src="@/assets/img/累计会员数.png" alt="">
            全部会员数
            <span class="numCss">{{numAll}}</span>
          </div>
        </el-col>
        <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" v-for="(item,index) in memberTypeData" :key="index">
          <div @click="toAdminManage(item.memberType)" :style="$route.name=='exportAdminGraph'?'':'cursor:pointer;'">
            <template v-if="item.memberType==1">
              <img src="@/assets/img/会长.png" alt="">
              会长（数）
            </template>
            <template v-if="item.memberType==2">
              <img src="@/assets/img/会长.png" alt="">
              副会长（数）
            </template>
            <template v-if="item.memberType==3">
              <img src="@/assets/img/理事会.png" alt="">
              理事会员（数）
            </template>
            <template v-if="item.memberType==4">
              <img src="@/assets/img/会员数量.png" alt="">
              普通会员（数）
            </template>
            <span class="numCss">{{item.memberNum}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row class="rowTwo">
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="commonCol echartsOneCol">
          <div class="commonTitle title">
            <h3>信用服务机构统计</h3>
            <el-select v-model="businessType" clearable placeholder="请选择业务类型" class="selectTypes" @change="oneEchartChange">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
            </el-select>
          </div>
          <div class="echarts echartsOne" id="echartsOne" ref="echartsOne" style="width:98%;height:100%;"></div>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="commonCol">
          <div class="commonTitle">
            <h3>会员总收入变化趋势</h3>
          </div>
          <div class="echarts echartsTwo" id="echartsTwo" ref="echartsTwo" style="width:100%;height:92%;"></div>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="commonCol">
          <div class="commonTitle">
            <h3>会员营业收入统计</h3>
          </div>
          <div class="echarts echartsThree" id="echartsThree" ref="echartsThree" style="width:100%;height:98%;"></div>
        </el-col>
      </el-row>
      <el-row class="rowThree">
        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
          <div class="commonTitle title">
            <h3 class="h3Sort">营业收入机构排名</h3>
            <el-select v-model="tableParams.year" placeholder="请选择年份" class="selectTypes selectSort" @change="getTableOneData">
              <el-option v-for="item in yearOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-select v-model="tableParams.operationType" clearable placeholder="请选择收入区间" class="selectTypes selectSort" @change="getTableOneData">
              <el-option v-for="item in incomeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-select v-model="tableParams.businessType" clearable placeholder="请选择业务类型" class="selectTypes selectSort" @change="getTableOneData">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
            </el-select>
            <el-row class="exportExcel" @click.native="exportsExcel">
              <img src="@/assets/img/export.png" alt=""> 导出excel
            </el-row>
          </div>
          <el-table :data="tableOneData" stripe style="width: 100%,height:100%" class="companyData">
            <el-table-column type="index" label="排名" width="70">
              <template slot-scope="scope">
                <img src="@/assets/img/第一.png" alt="" v-if="((pagination.pageNumber - 1)*10 + scope.$index)==0">
                <img src="@/assets/img/第二.png" alt="" v-if="((pagination.pageNumber - 1)*10 + scope.$index)==1">
                <img src="@/assets/img/第三.png" alt="" v-if="((pagination.pageNumber - 1)*10 + scope.$index)==2">
                <span class="content"> {{ (pagination.pageNumber - 1)*10 + scope.$index + 1 }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="companyName" label="公司名称" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="operatingIncome" label="营业收入（单位：千元）" v-if="$route.name!='exportAdminGraph'">
            </el-table-column>
          </el-table>
          <el-pagination :page-size="pagination.pageSize" :current-page="pagination.pageNumber" class="tablePage" @current-change="currentChange" @size-change="sizeChange" layout="prev, pager, next" :total="pagination.totalRows">
          </el-pagination>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="colTwo">
          <el-row class="one">
            <div class="commonTitle title">
              <h3>各年度及业务类型收入统计</h3>
              <el-select v-model="fourParams.year" placeholder="请选择年份" class="selectTypes" @change="fourEchartChange">
                <el-option v-for="item in yearOptions" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-select v-model="fourParams.businessType" clearable placeholder="请选择业务类型" class="selectTypes" @change="fourEchartChange">
                <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </div>
            <div class="echarts echartsFour" id="echartsFour" ref="echartsFour" style="width:100%;height:100%;"></div>
          </el-row>
          <el-row class="two">
            <div class="commonTitle title">
              <h3>各年份业务收入及其增长率统计</h3>
              <el-select v-model="fiveParams.year" placeholder="请选择年份" class="selectTypes" @change="fiveEchartChange">
                <el-option v-for="item in yearOptions" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-select v-model="fiveParams.incomeType" placeholder="请选择增长率类型" class="selectTypes" @change="fiveEchartChange">
                <el-option v-for="item in processOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <div class="echarts echartsFive" id="echartsFive" ref="echartsFive" style="width:100%;height:100%;"></div>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="rowFour">
        <h3>各年度会员企业从业人数及人均产值</h3>
        <el-row class="one">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
            <div class="commonTitle title">
              <h4>{{yearSixValue}}年人均产值</h4>
              <el-select v-model="yearSixValue" placeholder="请选择年份" class="selectTypes" @change="sixEchartsChange">
                <el-option v-for="item in yearOptions" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </div>
            <div class="echarts echartsSix" id="echartsSix" ref="echartsSix" style="width:100%;height:100%;"></div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
            <!-- <div style="margin-top:30px;"></div> -->
            <div class="echarts echartsSeven" id="echartsSeven" ref="echartsSeven" style="width:100%;height:111%;"></div>
          </el-col>
        </el-row>
        <el-row class="two">
          <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
            <div class="piechartsAll-name">{{this.yearSixValue?this.yearSixValue:'-' + '年'}}从业人员学历构成情况</div>
            <div class="echarts echartsEight" id="echartsEight" ref="echartsEight" style="width:100%;height:100%;"></div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
            <div class="piechartsAll-name">{{this.yearSixValue?this.yearSixValue:'-' + '年'}}从业人员从业年限构成情况</div>
            <div class="echarts echartsNine" id="echartsNine" ref="echartsNine" style="width:100%;height:100%;"></div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" v-if="tenLegendData[0]=='无'">
            <div class="piechartsAll-name">{{this.yearSixValue?this.yearSixValue:'-' + '年'}}从业人员专业技术职称构成情况</div>
            <div class="echarts echartsTen" id="echartsTen" ref="echartsTen" style="width:100%;height:100%;"></div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="9" v-else>
            <div class="piechartsAll-name">{{this.yearSixValue?this.yearSixValue:'-' + '年'}}从业人员专业技术职称构成情况</div>
            <div class="echarts echartsTen" id="echartsTen" ref="echartsTen" style="width:100%;height:100%;"></div>
          </el-col>
        </el-row>
      </el-row>
    </div>
  </div>
</template>
<script>
import adminGraphJs from '@/assets/js/AdminMember/adminGraph'


export default {
  ...adminGraphJs
}
</script>
<style lang='less' scoped>
.graph {
  .graphHeader {
    position: relative;
    width: 100%;
    height: 80px;
    line-height: 80px;
    background-color: #374e95;
    box-shadow: 2px -8px 40px 0px rgba(4, 0, 0, 0.18),
      inset 5px 36px 57px 0px rgba(0, 0, 0, 0.13);
    color: #f0f7fa;
    padding-left: 50px;
    font-size: 24px;
    margin-bottom: 50px;
    .headerMiddle {
      display: inline-block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 30px;
      z-index: 9999;
    }
    .headerImg {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 999;
    }
  }
  #adminGraph {
    padding: 0 25px;
    .exportHtml {
      position: fixed;
      top: 90%;
      right: 20%;
      border: 2px solid #0066cc;
      cursor: move;
      width: 110px;
      height: 36px;
      display: flex;
      align-items: center;
      border-radius: 18px;
      background: #fff;
      z-index: 999;
      box-shadow: 0px 0px 15px 0px rgba(1, 103, 204, 0.5);
      color: #286fc9;
      img {
        margin: 0 2px;
      }
    }
    /deep/.commonTitle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;
      .el-input {
        width: 90%;
      }
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
      .el-input__icon {
        line-height: 32px;
      }
    }
    .commonCol {
      padding: 0 25px;
    }
    .rowOne {
      background: #fff;
      height: 90px;
      padding: 14px;
      .el-col {
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #e0e0e0;
        height: 100%;
        color: #464a53;
        font-weight: 550;
        img {
          margin-right: 20px;
          vertical-align: middle;
        }
        .numCss {
          font-size: 24px;
          color: #248ae5;
          margin-left: 20px;
          font-weight: 500;
          vertical-align: middle;
        }
      }
      .el-col:nth-last-child(1) {
        border-right: none;
      }
    }
    /deep/.rowTwo {
      background: #fff;
      margin: 25px 0;
      padding: 20px 30px;
      height: 374px;
      .echartsOneCol {
        padding: 0 40px 0 0;
      }
      .el-col {
        border-right: 1px dashed #e0e0e0;
        height: 100%;
      }
      .el-col:nth-last-child(1) {
        border-right: none;
      }
    }
    /deep/.rowThree {
      padding: 20px 30px;
      height: 660px;
      background-color: #ffffff;
      .el-col {
        height: 100%;
      }
      .el-col:nth-child(1) {
        border-right: 1px dashed #e0e0e0;
        padding-right: 30px;
      }
      .title {
        h3 {
          width: 50%;
        }
        .selectTypes {
          margin-left: 10px;
          .el-input {
            width: 100% !important;
          }
        }
        .h3Sort {
          width: 40%;
        }
        .selectSort {
          margin-left: 5px;
          // width: 70% !important;
          .el-input {
            // width: 70% !important;
          }
        }
        .exportExcel {
          width: 160px;
          margin-left: 20px;
          color: #267243;
          cursor: pointer;
          img {
            vertical-align: middle;
            margin-right: 5px;
          }
        }
      }
      .companyData {
        // padding-right: 2.6%;
        img {
          margin-right: 10px;
        }
        .content {
          display: inline-block;
        }
      }
      .tablePage {
        margin-top: 10px !important;
      }
      .colTwo {
        padding-left: 20px;
        .one {
          height: 50%;
        }
        .two {
          height: 50%;
        }
      }
    }
    /deep/.rowFour {
      margin-top: 25px;
      height: 700px;
      background-color: #ffffff;
      padding: 20px 30px;
      .one {
        height: 340px;
        .el-col {
          height: 80%;
        }
        .el-col:nth-child(2) {
          padding-left: 20px;
        }
      }
      .two {
        height: 340px;
        margin-top: 25px;
        .el-col {
          height: 90%;
        }
      }
    }
  }
  .graphBody {
    width: 1350px;
    margin: 0 auto;
    .rowThree {
      .title {
        .h3Sort {
          width: 55% !important;
        }
        .exportExcel {
          width: 185px !important;
          margin-left: 5px !important;
          img {
            margin-right: 0 !important;
          }
        }
      }
    }
  }
  .piechartsAll-name {
    text-align: center;
    font-size: 18px;
    color: #000;
  }
}
</style>